<cmps-dialog class="cmps-cdk-min-w-384px">
    <cmps-dialog-header
        class="cmps-cdk-border-b-solid cmps-cdk-border-b-width-1p cmps-cdk-border-b-color-grey-300"
        [closeTooltip]="_i18n._11317_CLOSE | translate"
    >
        <div class="cmps-cdk-font-size-14p cmps-cdk-font-bold">
            {{ _i18n._11326_LEGEND | translate }}
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body class="cmps-cdk-p-1">
        <section>
            <div
                class="cmps-cdk-font-size-12p cmps-cdk-text-uppercase cmps-cdk-font-bold cmps-cdk-mb-0dot75 cmps-cdk-letter-spacing-0dot05 cmps-gp-color-ukn-101"
            >
                {{ _i18n._11327_PERSONAS | translate }}
            </div>
            <ul
                class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-m-0 cmps-cdk-p-0 cmps-cdk-g-0dot5"
            >
                <li
                    *ngFor="let p of _gpPersonas"
                    class="cmps-cdk-d-flex cmps-cdk-g-0dot5"
                >
                    <cmps-icon
                        class="{{ p.iconFill }}"
                        [svgIcon]="p.icon"
                        aria-hidden="true"
                    ></cmps-icon>
                    <div>
                        <div
                            class="cmps-cdk-font-size-13p cmps-gp-color-ukn-102"
                        >
                            {{ p.label | translate }}
                        </div>
                        <div
                            class="cmps-cdk-font-size-12p cmps-gp-color-ukn-101"
                        >
                            {{ p.description | translate }}
                        </div>
                    </div>
                </li>
            </ul>
        </section>

        <div
            class="cmps-cdk-my-1dot25 cmps-cdk-border-t-width-1px cmps-cdk-border-t-solid cmps-gp-border-t-color-ukn-100"
        ></div>

        <section>
            <h2
                class="cmps-cdk-font-size-12p cmps-cdk-text-uppercase cmps-cdk-font-bold cmps-cdk-mb-0dot75 cmps-cdk-letter-spacing-0dot05 cmps-gp-color-ukn-101"
            >
                {{ _i18n._11292_ACTIONS | translate }}
            </h2>
            <ul
                class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-m-0 cmps-cdk-p-0 cmps-cdk-g-0dot5"
            >
                <li
                    *ngFor="let a of _gpActions"
                    class="cmps-cdk-d-flex cmps-cdk-g-0dot5"
                >
                    <cmps-icon
                        class="{{ a.iconFill }}"
                        [svgIcon]="a.icon"
                        aria-hidden="true"
                    ></cmps-icon>
                    <div>
                        <div
                            class="cmps-cdk-font-size-13p cmps-gp-color-ukn-102"
                        >
                            {{ a.label | translate }}
                        </div>
                        <div
                            class="cmps-cdk-font-size-12p cmps-gp-color-ukn-101"
                        >
                            {{ a.description | translate }}
                        </div>
                    </div>
                </li>
            </ul>
        </section>
    </cmps-dialog-body>
</cmps-dialog>
